export default function (_name) {
  return {
    name: _name,
    props: {
      Data: {
        type: Object,
        default() {
          return {};
        },
      },
      SubmitData: {
        type: Object,
        default() {
          return {};
        },
      },
      SubmitInfo: {
        type: Object,
        default() {
          return {};
        },
      },
      TempFieldObj: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {};
    },
    computed: {
      data() {
        return this.Data;
      },
      events() {
        return this.Data.events || {};
      },
      submit_data() {
        return this.SubmitData;
      },
      submit_info() {
        return this.SubmitInfo;
      },
      temp_field_obj() {
        return this.TempFieldObj;
      },
      custom_attrs() {
        return this.Data.custom_attrs || {};
      },
      label_attr() {
        return this.custom_attrs.label || 'name';
      },
      value_attr() {
        return this.custom_attrs.value || 'key';
      },
    },
    methods: {
      setArrayValue() {
        if (!this.temp_field_obj[this.data.key]) {
          this.temp_field_obj[this.data.key] = {};
        }
        /* eslint-disable no-console */
        // console.log(this.custom_attrs);

        if (this.data.list && Array.isArray(this.data.list)) {
          this.data.list.forEach((item) => {
            this.temp_field_obj[this.data.key][item[this.value_attr] !== undefined
              ? item[this.value_attr] : item[this.label_attr]] = item[this.label_attr] !== undefined
              ? item[this.label_attr] : item[this.value_attr];
          });

          if (this.submit_data[this.data.key] !== undefined) {
            if (Array.isArray(this.submit_data[this.data.key])) {
              this.submit_info[this.data.key] = [];
              this.submit_data[this.data.key].forEach((item) => {
                if (this.temp_field_obj[this.data.key][item]) {
                  this.submit_info[this.data.key].push(this.temp_field_obj[this.data.key][item]);
                }
              });
            } else {
              this.submit_info[this.data.key] = '';
              if (this.temp_field_obj[this.data.key][this.submit_data[this.data.key]]) {
                this.submit_info[this.data.key] = this.temp_field_obj[this.data.key][this.submit_data[this.data.key]];
              }
            }
          }
        }
      },

      setDefaultFieldByNoDefaultValue() {
        if (this.submit_data[this.data.key] === undefined) {
          this.submit_data[this.data.key] = '';
        }
      },

      init() {},
    },

    created() {
      this.setDefaultFieldByNoDefaultValue();
      this.setArrayValue();
    },

    mounted() {
      this.init();
    },

    watch: {
      $route() {
        this.init();
      },
    },
  };
}
